module.exports = __webpack_public_path__ + "static/media/directions_ko@2x.1d9c1a14.png";